document.querySelectorAll('a[href]').forEach(link => {
    const href = link.getAttribute('href');
    const isExternal = (() => {
        try {
            const linkUrl = new URL(href, window.location.origin);
            return linkUrl.origin !== window.location.origin;
        } catch (e) {
            return false; // ignore malformed or relative links
        }
    })();

    const isPdf = href.endsWith('.pdf');

    if ((isExternal || isPdf) && link.getAttribute('target') !== '_blank') {
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'noopener noreferrer'); // security best practice
    }
});
